<template>
  <div class="listing-card">
    <router-link
      :to="listingLink">
      <listing-image
        class="mb-2"
        :src="listing.imageUrl"/>
    </router-link>
    <router-link
      :to="listingLink">
      <h2 class="text-dark h4">
        {{ listing.title }}
      </h2>
    </router-link>
    <h3
      class="text-primary h3">
      {{ listing.price | currency }}
    </h3>
    <slot name="actions"/>
  </div>
</template>

<script>
import truncate from '@/filters/truncate.filter'
import currency from '@/filters/currency.filter'
import ListingImage from '@/components/images/ListingImage.vue'

export default {
  name: 'ListingCard',
  components: {
    ListingImage,
  },
  props: ['listing'],
  filters: {
    currency,
    truncate,
  },
  computed: {
    listingLink() {
      return `/listing/${this.listing.id}/${this.urlSafeTitle}`
    },
    urlSafeTitle() {
      return this.listing
        ? this.listing.title
          .trim()
          .replace(/[^a-zA-Z0-9-]/g, '-')
          .replace(/-+/g, '-')
          .toLowerCase()
        : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.listing-card {
  border-radius: 5px;
  box-sizing: border-box;
}
</style>
